import { Component, EventEmitter, Output } from '@angular/core';
import { BooleanFilter } from '../local-types/BooleanFilter';

@Component({
  selector: 'app-boolean-filter',
  templateUrl: './boolean-filter.component.html',
  styleUrls: ['./boolean-filter.component.scss']
})
export class BooleanFilterComponent {
  @Output() public selectionChanged = new EventEmitter<BooleanFilter>();
  
  public filter: BooleanFilter = { yes: false, no: false };

  public hasFilterSelected(): boolean {
    return this.filter && (this.filter.yes || this.filter.no);
  }

  public invokeSelectionChanged(): void {
    this.selectionChanged.emit(this.filter);
  }

  public clearFilters(): void {
    this.filter = { yes: false, no: false };
    this.invokeSelectionChanged();
  }
}
